import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { STATIC_ROOT } from '../../../constants';
import { MEMBRE_VERSION_MENU_MOBILE_SLIDE } from '../../../services/header/constants';

import { toggleMenuMobileSlide } from '../../../services/header/actions';

import SvgComponent from '../../SvgComponent';
import LoggedInComponent from './LoggedInComponent';
import LoggedOutComponent from './LoggedOutComponent';
import { LoadingComponent } from '../../loading/LoadingComponent';

import './MemberNavComponent.scss';

class MemberNavComponent extends Component {
    onClickBtMenuMobile(e) {
        e.preventDefault();
        this.props.dispatch(toggleMenuMobileSlide(MEMBRE_VERSION_MENU_MOBILE_SLIDE));
    }

    handleKeyDown = e => {
        if (e.keyCode === 13) {
            e.preventDefault();
            this.props.dispatch(toggleMenuMobileSlide(MEMBRE_VERSION_MENU_MOBILE_SLIDE));
        }
    };

    render() {
        const { i18n, i18nAccessibility, isAuthenticated, fetching, user } = this.props;
        return (
            <div className="menu-membre flex-container-h flex-center-alt">
                {fetching ? (
                    <LoadingComponent />
                ) : (
                    <React.Fragment>
                        <div
                            id="mobile-member-menu-button-open"
                            className="menu-membre-ico curpt"
                            onClick={this.onClickBtMenuMobile.bind(this)}
                            onKeyDown={this.handleKeyDown}
                            tabIndex="0">
                            <SvgComponent
                                src={`${STATIC_ROOT}/picto-connexion.svg`}
                                width="20"
                                height="20"
                                aria-hidden="true"
                                focusable="false"
                            />
                            <span className="sr-only">
                                {i18nAccessibility.MEMBER_MENU_BUTTON_OPEN}
                            </span>
                        </div>
                        {isAuthenticated ? (
                            <LoggedInComponent>
                                {user && user.firstname && user.lastname ? (
                                    <span className="menu-membre-name">{i18n.MY_ACCOUNT}</span>
                                ) : (
                                    i18n.SEE_MY_ACCOUNT
                                )}
                            </LoggedInComponent>
                        ) : (
                            <LoggedOutComponent />
                        )}
                    </React.Fragment>
                )}
            </div>
        );
    }
}

MemberNavComponent.propTypes = {
    user: PropTypes.object.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    fetching: PropTypes.bool.isRequired,
    stateOpenMenuMobileSlide: PropTypes.bool.isRequired,
    versionOpenMenuMobileSlide: PropTypes.string.isRequired,
    i18n: PropTypes.object.isRequired
};

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
    return {
        i18n: state.i18n.feature.header.MEMBER_NAV,
        i18nAccessibility: state.i18n.feature.header.ACCESSIBILITY
    };
}

export default connect(mapStateToProps)(MemberNavComponent);



// WEBPACK FOOTER //
// ./src/components/header/membernav/MemberNavComponent.js